import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    disqualifyReasons: {
      selectIds: [],
      filters: {},
      selectId: false
    }
  },
  mutations: {
    SET_DISQUALIFYREASON_SELECT_IDS (store, ids) {
      store.disqualifyReasons.selectIds = ids
    },
    REMOVE_DISQUALIFYREASON_SELECT_IDS (store, ids) {
      store.disqualifyReasons.selectIds = store.disqualifyReasons.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_DISQUALIFYREASON_SELECT_ID (store, id) {
      store.disqualifyReasons.selectId = id
    },
    SET_DISQUALIFYREASON_FILTERS (store, filters) {
      store.disqualifyReasons.filters = filters
    }
  },
  getters: {
    getDisqualifyReasons: (store, getters) => {
      return store.disqualifyReasons.selectIds.map((id) => {
        return getters['entities/disqualifyReasons/find'](id)
      })
    },
    getDisqualifyReasonsFilters: (store, getters) => {
      return store.disqualifyReasons.filters
    },
    getDisqualifyReason: (store, getters) => {
      return getters['entities/disqualifyReasons/find'](store.disqualifyReasons.selectId) || {}
    }
  },
  actions: {
    /*
    selectDisqualifyReasons
    */
    selectDisqualifyReasons ({commit, dispatch, getters, state}, filters) {
      return dispatch('getDisqualifyReasons', filters)
      .then((response) => {
        commit('SET_DISQUALIFYREASON_FILTERS', filters)
        commit('SET_DISQUALIFYREASON_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectDisqualifyReasons
    */
    refreshSelectDisqualifyReasons ({commit, dispatch, getters, state}) {
      return dispatch('selectDisqualifyReasons', getters.getDisqualifyReasonsFilters)
    },
    /*
    selectDisqualifyReason
    */
    selectDisqualifyReason ({commit, dispatch, getters, state}, id) {
      return dispatch('getDisqualifyReasonById', id)
      .then((response) => {
        commit('SET_DISQUALIFYREASON_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getDisqualifyReasons
    */
    getDisqualifyReasons ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/disqualify-reasons`, {params: filters})
      .then((response) => {
        return dispatch('entities/disqualifyReasons/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.disqualifyReasons || []
      })
    },
    /*
    getDisqualifyReasonById
    */
    getDisqualifyReasonById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/disqualify-reasons/${id}`)
      .then((response) => {
        return dispatch('entities/disqualifyReasons/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.disqualifyReasons[0]
      })
    },
    /*
    createDisqualifyReason
    */
    createDisqualifyReason ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/disqualify-reasons`, data)
      .then((response) => {
        return dispatch('entities/disqualifyReasons/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.disqualifyReasons[0]
      })
    },
    /*
    updateDisqualifyReason
    */
    updateDisqualifyReason ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/disqualify-reasons/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/disqualifyReasons/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.disqualifyReasons[0]
      })
    },
    /*
    mergeDisqualifyReasons
    */
    mergeDisqualifyReasons ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/disqualify-reasons/merge`, data)
      .then((response) => {
        return dispatch('entities/disqualifyReasons/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.disqualifyReasons[0]
      })
    },
    /*
    deleteDisqualifyReason
    */
    deleteDisqualifyReason ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/disqualify-reasons/${id}`)
      .then((response) => {
        commit('REMOVE_DISQUALIFYREASON_SELECT_IDS', [id])
        dispatch('entities/disqualifyReasons/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/DisqualifyReason.js